import colors from '@/styles/colors';
import styled from 'styled-components';

export const SignInOptions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
`;

export const SignInFooter = styled.div`
  color: ${colors.hardGray};
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  margin-top: 24px;

  a {
    margin-left: 3px;
  }
`;

export const SignInOptionsContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AuthHr = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: ${colors.hardGray};

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background-color: ${colors.secondaryLite};
  }
`;

export const RegisterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  justify-content: flex-end;

  span {
    text-align: center;
    color: ${colors.hardGray};
    font-weight: 600;
  }
`;
